export default {
  title: "Amaliyotlar tarixi",
  number: "Raqam",
  entityName: "Tashkilot nomi",
  type: "Amaliyot turi",
  typeBuyTariff: "Tarif sotib olish",
  typeAddBalance: "Balansni to‘ldirish",
  typePaymentAct: "Hisob bo‘yicha to‘lov",
  typePaymentAcceptance: "Test to‘lovi",
  amount: "Miqdor",
  currency: "Valyuta",
  date: "Sana va vaqt",
  noHistory: "Sizning tarixingiz bo‘sh",
  operationsTab: "Barcha amaliyotlar",
  processingTab: "RC Processing",
  reward: "Mukofot",
  paidFromPurchase:
    "{cash} {currency} to‘landi <span>({amount} {currency} bo‘lgan xariddan)</span>",
  downloadModal: {
    title: "Faylni yuklab olish",
    fileType: "Fayl turi",
    sendOnEmail: "Nusxani elektron pochtaga yuborish",
    CPUnloadingOperationHistory: "(KP) Amaliyotlar tarixini yuklab olish",
  },
  couldntCreateUnloading: "Yuklab olishni yaratib bo‘lmadi",
  giftCard: "Sovg‘a kartasi",
  orderNumber: "Buyurtma raqami",
  paymentMethod: "To‘lov usuli",
  inCheckSpecifiedPercentAndSumAward:
    "Chekda umumiy foiz va mukofot summasi ko‘rsatilgan.",
  itsMayNotMatchWithFactSum:
    "U haqiqiy chiqarilgan ballar summasi bilan mos kelmasligi mumkin, chunki bu qaysi mijoz xarid qilgani (ichki yoki tashqi) va uning tarifiga bog‘liq.",
};
